import { Box, Button, Fade, Modal } from '@mui/material'

import Cafgu2 from '../../../../assets/images/core/cafgu_bg.png'
import { domain, env } from '../../../../core/Env';

const Account = ({welcome, cafguModal}) => {

     const tool_id = (env() === 'dev' ? 366 : (env() === 'sb' ? 298 : 332))
       

        const handleClose = async (type) => {
        if ( type === 'log' ) {
             let tsa_key = (env() === 'dev' ? "WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2hWeW4=" : (env() === 'sb' ? "WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2hGT3A=" : "WEIrd1cyTnR2L2FZeFhBZDRCc3NWbnN2VUVGN2hWbWo="))
             window.location.href = `${domain('pm').url}/sso/rqx?from=${tsa_key}&callback=${env() === 'dev' || env() === 'local' || env() === 'sb' ? 'sandbox' : 'production'}&platform=business`
            } else if (type === 'reg' ) {
                let subscription = (env() === 'dev' ? 'c3Vic2NyaXB0aW9uXzYyOQ==' : (env() === 'sb' ? 'c3Vic2NyaXB0aW9uXzM5OQ==' : 'c3Vic2NyaXB0aW9uXzMzMQ=='))
                window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${tool_id}`)}&callback=${env()}&platform=business&subscription=${subscription}&ref=unauth&auth_type=registration`;
                } else {           
                    cafguModal.set(true)
                    welcome.set(false)
                }
     
        };

  return (
        <Modal
            open={welcome.data}
            closeAfterTransition
            >
            <Fade in={welcome.data}>
                <Box 
                    display="flex" 
                    justifyContent="center" 
                    alignItems="center" 
                    height="100vh"
                    bgcolor='transparent'
 
                    sx={{ 
                        backdropFilter: "blur(6px)",
                        backgroundColor: "rgba(0,0,0,0.4)"
                    }}
                >
                    <Box
                        width={420}
                        bgcolor="#FFFFFF"
                        borderRadius={4}
                        boxShadow="0 8px 30px rgba(0,0,0,0.15)"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={3}
                    >
                    {/* Image */}
                        <img 
                            src={Cafgu2}
                            width={420}
                            alt="Cafgu2"
                            height={200}
                            style={{ borderRadius: "12px" }}
                        
                        />

                        {/* Buttons Section */}
                        <Box width="100%" display="flex" flexDirection="column" alignItems="center" gap={2}  p={4}>

                              <Button
                                onClick={() => handleClose('guest')}
                                    // variant="outlined"
                                    sx={{
                                    height: "40px",
                                    width: "100%",
                                    borderRadius: "10px",
                                    borderColor: "#A3A3A3",
                                    bgcolor: '#035827',
                                    color: "#fff",
                                    fontWeight: 600,
                                    transition: "0.2s",
                                    ":hover": {
                                        bgcolor: "#035827",
                                        color: "#FFFFFF",
                                        borderColor: "#035827"
                                    }
                                }}
                            >
                                Continue without account
                            </Button>
                              <Box fontWeight={500} fontSize="14px" color="#7A7A7A">or</Box>
                    
                            <Button
                                onClick={() => handleClose('log')}
                                    variant="outlined"
                                    sx={{
                                    height: "40px",
                                    width: "100%",
                                    borderRadius: "10px",
                                    borderColor: "#03A36E",
                                    color: "#444",
                                    // color: "#03A36E",
                                    fontWeight: 600,
                                    transition: "0.2s",
                                    ":hover": {
                                        bgcolor: "#03A36E",
                                        color: "#FFFFFF",
                                        borderColor: "#03A36E"
                                    }
                                }}
                            >
                                Login existing account
                            </Button>
                          

                          
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    )
}

export default Account
